module.exports = __webpack_public_path__ + "static/media/hall-PA.e61a8773.svg";